/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./MessagesChatBubble.vue?vue&type=template&id=5940d6d3&scoped=true"
import script from "./MessagesChatBubble.vue?vue&type=script&lang=js"
export * from "./MessagesChatBubble.vue?vue&type=script&lang=js"
import style0 from "./MessagesChatBubble.vue?vue&type=style&index=0&id=5940d6d3&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5940d6d3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5940d6d3')) {
      api.createRecord('5940d6d3', component.options)
    } else {
      api.reload('5940d6d3', component.options)
    }
    module.hot.accept("./MessagesChatBubble.vue?vue&type=template&id=5940d6d3&scoped=true", function () {
      api.rerender('5940d6d3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/messages/MessagesChatBubble.vue"
export default component.exports